import TestimonialCardsV2 from './TestimonialCardsV2'
export default TestimonialCardsV2
